import { render, staticRenderFns } from "./accountHistory.vue?vue&type=template&id=08616380&scoped=true&"
import script from "./accountHistory.vue?vue&type=script&lang=js&"
export * from "./accountHistory.vue?vue&type=script&lang=js&"
import style0 from "./accountHistory.vue?vue&type=style&index=0&id=08616380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08616380",
  null
  
)

export default component.exports